import {GridApi} from '@ag-grid-community/core';
export const agGridForEach = (
  param: GridApi | null,
  orderFiledName: string = '',
  changeFieldA: string = '',
  changValueA?: any
  // changeFieldB: string = '',
  // changValueB?: any
) => {
  let dataArr: Array<any> = [];
  param?.forEachNode((rowNode, index) => {
    if (orderFiledName !== '') {
      // 순서는 항상 1부터 시작해야함.
      rowNode.data[orderFiledName] = index + 1;
    }
    if (changeFieldA !== '') {
      rowNode.data[changeFieldA] = changValueA;
    }
    dataArr.push(rowNode.data);
  });
  return dataArr;
};
